<template>
  <layout :titlePage="'Solicitar transferência'" :route="{ name: backRoute }">
    <submenuBack v-if="hasToShowNewMenu" />
    <section class="c-withdraw-pix">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column is-two-fifths pix-register-account--header">
          <base-header-page
            class="c-base-header-page--full c-withdraw-pix__header-page"
          >
            <base-icon name="pix" width="160px" height="40px" />
          </base-header-page>
        </div>
        <div class="column c-withdraw-pix--height">
          <WalletHolidayNotice
            :visibleRanges="[
              {
                start: new Date('2025-04-25T03:00:00.000Z'), // 25/04/2025 00:00
                end: new Date('2025-05-01T02:59:59.999Z'), // 30/04/2025 23:59
              }
            ]"
          />

          <WalletHolidayWarning :visibleRanges="[holidays[0]]" />

          <h6 class="c-screen-middle-title" v-if="hasToShowNewMenu">
            Solicitar transferência
          </h6>

          <div class="pix-register-account__steps-pix">
            <BaseSteps :steps="steps" :content="'pix'" />
          </div>
          <WithdrawWithPix :disabled="isHoliday" />
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import BaseSteps from '@/components/Wallet/BaseSteps.vue'
import WithdrawWithPix from '@/components/Wallet/Pix/Withdraw/WithdrawWithPix.vue'
import layout from '@/layouts/Default.vue'
import submenuBack from '@/layouts/parts/SubmenuBack.vue'

import loadingViewMixin from '@/mixins/loadingViewMixin'
import walletDataMixin from '@/mixins/walletDataMixin'

import WalletHolidayNotice from '@/components/Wallet/WalletHolidayNotice.vue'
import WalletHolidayWarning from '@/components/Wallet/WalletHolidayWarning.vue'

export default {
  mixins: [loadingViewMixin, walletDataMixin],

  components: {
    BaseSteps,
    layout,
    submenuBack,
    BaseHeaderPage,
    WithdrawWithPix,
    WalletHolidayNotice,
    WalletHolidayWarning,
  },

  metaInfo: {
    title: 'Transferência por PIX',
  },
  computed: {
    userDataTransfer() {
      return this.$store.state.wallet.userDataTransfer
    },

    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  data() {
    return {
      backRoute: 'carteira-saque',
      holidays: [
        {
          start: new Date('2025-05-01T03:00:00.000Z'), // 01/05/2025 00:00
          end: new Date('2025-05-02T02:59:59.999Z'), // 01/05/2025 23:59
        },
      ],
      isHoliday: false,
    }
  },

  created() {
    this.walletSummary.loading ||
    (!this.walletSummary.balance && !this.walletSummary.owner_cpf)
      ? this.$router.push({ name: 'carteira' })
      : (this.getRouterBack(this.$route.params.from),
        this.tranferType(this.$route.params.transfer))

    const today = new Date()

    this.isHoliday = this.holidays.some(
      ({ start, end }) => today >= start && today <= end
    )
  },

  mounted() {
    this.loading = true
    this.isPixPendencies()
  },

  methods: {
    tranferType(transfer) {
      if (transfer === 'cc') {
        this.title = 'dados bancários'
        this.typeRegister = 'Conta bancária'
      }

      this.steps = [
        {
          step: 'Titular',
          active: true,
        },
        {
          step: 'PIX',
          active: true,
        },
        {
          step: 'Valor',
          active: true,
        },
        {
          step: 'Conclusão',
        },
      ]
    },

    getRouterBack(route) {
      route == 'carteira-cadastro-pix'
        ? (this.backRoute = 'carteira-cadastro-pix')
        : ''
    },

    isPixPendencies() {
      if (
        (this.walletSummary && !this.userDataTransfer) ||
        !this.walletSummary.owner_cpf
      )
        return this.$router.push({ name: 'carteira' })
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.layout {
  min-height: 100vh;
}
.c-withdraw-pix {
  .wallet-holiday-notice-wrapper {
    width: auto;
    max-width: 415px;
    margin-left: auto;
    margin-right: auto;
  }

  @media screen and (max-width: 470px) {
    .wallet-holiday-notice-wrapper {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  &__header-page {
    background-color: $support !important;

    @media (min-width: $tablet) {
      .svg-icon {
        width: 260px;
        height: 80px;
      }
    }
  }

  &--height {
    @media (min-width: $tablet) {
      margin: 0 30px !important;
      min-height: calc(80vh - 60px) !important;
      height: auto;
    }
  }
}
</style>
